import { Dots } from '@cleartrip/bento/lib';
import Sandbox from '@components/Sandbox';
import Playground from '@components/Playground';
import * as React from 'react';
export default {
  Dots,
  Sandbox,
  Playground,
  React
};